import { fetchRequest } from "../Fetcher";
import { pollJobUntilDone } from "./PollJobUntilDone";

export const runSceneGenerationJob = async ({
  storyboardId,
  numberOfScene,
  applyBrandGuideline = true,
  onProgress,
}) => {
  onProgress?.("AI is generating storyboard scenes...");

  const { result } = await fetchRequest({
    method: "POST",
    path: `sessions/storyboards/${storyboardId}/scenes/generate`,
    data: JSON.stringify({
      numberOfScene,
      applyBrandGuideline,
    }),
  });

  const jobs = result?.jobs ?? [];

  if (!jobs.length) {
    console.error("Scene generate response:", result);
    throw new Error("Scene generation job not created");
  }

  const scenes = await Promise.all(
    jobs.map(async (job, index) => {
      onProgress?.(`Generating scene ${index + 1} of ${jobs.length}...`);

      await pollJobUntilDone({
        getStatus: () =>
          fetchRequest({
            method: "GET",
            path: `sessions/storyboards/${storyboardId}/scenes/${job.scene_id}/status`,
          }),
      });

      const { result: sceneResult } = await fetchRequest({
        method: "GET",
        path: `sessions/storyboards/${storyboardId}/scenes/${job.scene_id}`,
      });

      return sceneResult?.data ?? sceneResult;
    })
  );

  return scenes;
};